import { render, staticRenderFns } from "./takeMoneybyInvoice.vue?vue&type=template&id=bdadfff2"
import script from "./takeMoneybyInvoice.vue?vue&type=script&lang=js"
export * from "./takeMoneybyInvoice.vue?vue&type=script&lang=js"
import style0 from "./takeMoneybyInvoice.vue?vue&type=style&index=0&id=bdadfff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports